// src/config.ts

// 1. 현재 접속한 브라우저 주소가 로컬(내 컴퓨터)인지 확인
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// 2. 환경에 맞춰 백엔드 진짜 주소(루트) 세팅
// 💡 여기에 실제 배포된 백엔드 서버의 IP나 도메인을 적어주세요!
export const BACKEND_URL = isLocalhost 
  ? 'http://localhost:8000' 
  : 'https://aiscram-1012872696313.asia-northeast3.run.app'; 

// 3. /api 가 붙은 공통 API 주소도 미리 만들어두기
export const API_BASE_URL = `${BACKEND_URL}/api`;

//강제푸시위해 주석으로 텍스트 추가